export default "__VITE_ASSET__i5rUiLVv__"